export const commonListOptions = [
  'Production',
  'Utilization',
  'Fuel',
  'Avg Fuel Rate',
  'Engine Hours',
  'Idling Hours',
  'Productive Hours',
];

export const loaderListOptions = [
  'Utilization',
  'Fuel',
  'Avg Fuel Rate',
  'Engine Hours',
  'Idling Hours',
  'Productive Hours',
];

export const utilizationSortOptions = ['Least Utilization', 'Most Utilization'];
